import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import {
  CommonModule,
  CurrencyPipe,
  DatePipe,
  registerLocaleData,
} from '@angular/common';
import { CustomMaterialModule } from './@theme/custom-material.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

import { MAT_SELECT_CONFIG } from '@angular/material/select';
import {
  OWL_DATE_TIME_LOCALE,
  OwlDateTimeIntl,
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { PolishOwlDateTimeIntl } from './_services/datepicker-config';

import localePl from '@angular/common/locales/pl';
import localeFr from '@angular/common/locales/fr';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { CodeEditorModule } from '@ngstack/code-editor';
registerLocaleData(localePl, 'pl');
registerLocaleData(localeFr, 'fr-FR');
import 'moment/locale/pl';
import { MarkdownModule } from 'ngx-markdown';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@NgModule({
  declarations: [AppComponent],
  exports: [],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    AngularSvgIconModule.forRoot(),
    CodeEditorModule.forRoot({ baseUrl: 'assets/monaco' }),
    MarkdownModule.forRoot(),
    NgxExtendedPdfViewerModule,
  ],
  providers: [
    CurrencyPipe,
    DatePipe,
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { overlayPanelClass: 'mat-select-panel-overlay' },
    },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    { provide: OWL_DATE_TIME_LOCALE, useValue: 'pl' },
    { provide: MAT_DATE_LOCALE, useValue: 'pl' },
    { provide: OwlDateTimeIntl, useClass: PolishOwlDateTimeIntl },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
